import '@/assets/custom-element-v2.css';

import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

import App from './App.vue';
import store from './store';

// Initialize Sentry
Sentry.init({
  Vue: Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN ?? '',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
  release: process.env.VUE_APP_SENTRY_RELEASE,
});

Vue.config.productionTip = false;

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
